import dayjs from 'dayjs'
export default {
  created() {
    console.log(111)
  },
  methods: {
    // 点击购买人证件类型
    clickCardType() {
      this.cardIndex = -1
      this.showTypeFlag = true
    },
    // 证件类型 确认证件类型
    confirmCardType(val) {
      console.log(
        '证件类型',
        val,
        'this.cardIndex',
        this.cardIndex,
        'appntInfo',
        this.appntInfo.appntIdType
      )
      if (this.cardIndex === -1) {
        this.appntInfo.appntIdTypeName = val.text
        this.appntInfo.appntIdType = val.type
        // this.$refs.buyInfoForm.validate('appntIdNo').catch(() => {})
        this.$refs.buyInfoForm.resetValidation('appntIdNo')
        this.$refs.buyInfoForm.resetValidation('appntName')
        this.$refs.buyInfoForm.validate('appntName').catch(() => {})
        this.setAppntBirthdayGender()
      }
      if (this.cardIndex >= 0) {
        this.insuredList[this.cardIndex].insuredPersonTypeName = val.text
        this.insuredList[this.cardIndex].insuredPersonIdType = val.type
        this.$refs.buyInfoForm.resetValidation(
          'insuredPersonName' + this.cardIndex
        )
        this.$refs.buyInfoForm
          .validate('insuredPersonName' + this.cardIndex)
          .catch(() => {})
        this.$refs.buyInfoForm.resetValidation(
          'insuredPersonIdNo' + this.cardIndex
        )
        this.setInsuredBirthdayGender(this.cardIndex)
      }
      this.cardIndex = ''
      this.showTypeFlag = false
    },
    // 点击购买人选择生日
    clickBirthday() {
      this.cardIndex = -1
      this.showBirthdayFlag = true
    },
    // 购买人选择生日变化
    appntBirthdayChange() {
      this.$refs.buyInfoForm.resetValidation('appntIdNo')
      this.$refs.buyInfoForm.validate('appntIdNo').catch(() => {})
    },
    // 确定时间选择后的时间
    onConfirmBirthday(val) {
      const currentDate = dayjs(val).format('YYYY-MM-DD')
      if (this.cardIndex === -1) {
        this.appntInfo.birthday = currentDate
      }
      if (this.cardIndex >= 0) {
        this.insuredList[this.cardIndex].birthday = currentDate
      }
      this.cardIndex = ''
      this.showBirthdayFlag = false
    },
    formatterDate(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      }
      return val
    }
  }
}
